import { defineMessages } from "react-intl";
const messages = defineMessages({
    createProspectSuccess: {
        id: "app.spaces.actions.createProspect.success.text",
        defaultMessage: "Prospect created successfully.",
    },
    createProspectTitle: {
        id: "app.spaces.actions.createProspect.title.text",
        defaultMessage: "Create New Prospect",
    },
    createProspectButton: {
        id: "app.spaces.actions.createProspect.button.text",
        defaultMessage: "Create Prospect",
    },
    createProspectFormEmail: {
        id: "app.spaces.actions.createProspect.form.email.text",
        defaultMessage: "Email Address",
    },
    createProspectFormFirstName: {
        id: "app.spaces.actions.createProspect.form.firstName.text",
        defaultMessage: "First Name",
    },
    createProspectFormLastName: {
        id: "app.spaces.actions.createProspect.form.lastName.text",
        defaultMessage: "Last Name",
    },
    createProspectFormPhoneNumber: {
        id: "app.spaces.actions.createProspect.form.phoneNumber.text",
        defaultMessage: "Phone Number",
    },
});
export default messages;
